import Vue from 'vue'
import store from '@/store/index'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home/Home.vue')
  }, {
    path: '/preview/musicKnowledge/instruments',
    name: 'MusicKnowledgeInstruments',
    title: '音乐知识 - 乐器',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/preview/musicKnowledge/Index.vue')
  }, {
    path: '/preview/musicKnowledge/musician',
    name: 'MusicKnowledgeMusician',
    title: '音乐知识 - 音乐家',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/preview/musicKnowledge/Index.vue')
  }, {
    path: '/preview/musicKnowledge/instrumentsDetail',
    name: 'MusicKnowledgeInstrumentsDetail',
    title: '音乐知识 - 乐器详情',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/preview/musicKnowledge/Detail.vue')
  }, {
    path: '/preview/musicKnowledge/musicianDetail',
    name: 'MusicKnowledgeMusicianDetail',
    title: '音乐知识 - 音乐家详情',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/preview/musicKnowledge/Detail.vue')
  }, {
    path: '/preview/musicKnowledge/player',
    name: 'MusicKnowledgePlayer',
    title: '音乐知识 - 播放',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/preview/musicKnowledge/Player.vue')
  }, {
    path: '/preview/musicKnowledge/theory',
    name: 'MusicKnowledgeTheory',
    title: '乐理知识',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/preview/musicKnowledge/Theory.vue')
  }, {
    path: '/preview/musicScore/web',
    name: 'MusicKnowledgeMusicScoreWeb',
    title: '魔欢音乐教育 - 曲谱',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/preview/musicScore/MusicScoreWeb.vue')
  }, {
    path: '/login',
    name: 'Loign',
    title: '魔欢音乐教育 - 登录',
    component: () => import('../views/login/Login.vue')
  }, {
    path: '/preview/musicRhythm/edit',
    name: 'Rhythm',
    title: '音乐律动创作',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/rhythm/Index.vue')
  }, {
    path: '/preview/musicRhythm/web',
    name: 'RhythmPlayer',
    title: '音乐律动播放',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/rhythm/Player.vue')
  }, {
    path: '/draw/random',
    name: 'DrawRandom',
    title: '随机点名',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/draw/Random.vue')
  }, {
    path: '/banner',
    name: 'Banner',
    title: '信息屏',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/banner/Banner.vue')
  },
  {
    path: '/ebook/:id',
    name: 'EBook',
    title: '电子教材',
    component: () => import('../views/ebook/Index.vue')
  },
  {
    path: '*',
    name: 'NotFound',
    title: '魔欢音乐教育',
    component: () => import('../views/home/Home.vue')
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

router.beforeEach((to, from, next) => {
  // 记录当前设备
  if (to.query.deviceType) { store.commit('changeDeviceType', to.query.deviceType) }

  if (to.meta.requiresAuth) {
    // 从请求头拿 token
    const queryToken = to.query.token
    if (queryToken) {
      // 判断是否是机顶盒，来判断是否需要保存token
      if (to.query.deviceType !== 'stb') {
        try {
          localStorage.setItem('token', queryToken)
        } catch {}
      }
      store.commit('changeToken', queryToken)
      const query = to.query
      delete query.token
      return next({ name: to.name, query })
    }
    // Vuex 中有 token
    if (store.state.token) {
      return next()
    }
    // 从 sessionStorage 中获取 token
    const sessionToken = localStorage.getItem('token')
    if (sessionToken) {
      store.commit('changeToken', sessionToken)
      return next()
    }
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
  return next()
})

export default router
